import { IUser } from './../../account/api/user.interfaces';
import { IStore } from './../../stores/api/store.interface';
import { ICompany } from './../../companies/api/company.interface';
import axios from 'axios';
import { IAllowedUser, IRefreshToken } from './admin.interfaces';
import { BaseService } from '@/features/base/api/base.api';

class AdminService extends BaseService {
  private static instance: AdminService;

  private constructor() {
    super();
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public getUsers(): Promise<IApi<IUser[]>> {
    return this.get<IUser[]>(`${this.baseUrl}/api/admin/users`);
  }

  public deleteUser(id: string): Promise<IApi<string>> {
    return this.deleteItem<string>(`${this.baseUrl}/api/admin/users/${id}`);
  }

  public getCompanies(): Promise<IApi<ICompany[]>> {
    return this.get<ICompany[]>(`${this.baseUrl}/api/admin/companies`);
  }

  public deleteCompany(id: string): Promise<IApi<string>> {
    return this.deleteItem<string>(`${this.baseUrl}/api/admin/companies/${id}`);
  }

  public getStores(): Promise<IApi<IStore[]>> {
    return this.get<IStore[]>(`${this.baseUrl}/api/admin/stores`);
  }

  public deleteStore(id: string): Promise<IApi<string>> {
    return this.deleteItem<string>(`${this.baseUrl}/api/admin/stores/${id}`);
  }

  public getRefreshTokens(): Promise<IApi<IRefreshToken[]>> {
    return this.get<IRefreshToken[]>(`${this.baseUrl}/api/admin/refreshtokens`);
  }

  public deleteRefreshToken(id: string): Promise<IApi<string>> {
    return this.deleteItem<string>(`${this.baseUrl}/api/admin/refreshtokens/${id}`);
  }

  public addAllowedUser(allowedUser: IAllowedUser): Promise<IApi<IAllowedUser>> {
    return this.postItem<IAllowedUser>(`${this.baseUrl}/api/admin/alloweduser`, allowedUser);
  }

  public getAllowedUsers(): Promise<IApi<IAllowedUser[]>> {
    return this.get<IAllowedUser[]>(`${this.baseUrl}/api/admin/alloweduser`);
  }

  public deleteAllowedUser(id: string): Promise<IApi<string>> {
    return this.deleteItem<string>(`${this.baseUrl}/api/admin/alloweduser/${id}`);
  }
}

export const adminService = AdminService.Instance;
